import alert from '@/plugins/alert'
import { ToolApi } from '../../plugins/api'
export default {
  namespaced: true,
  state: {
    tools: [],
  },
  actions: {
    async fetchTools({ commit }, options) {
      try {
        commit('setTools', await ToolApi.fetch(options))
      } catch (error) {
        alert.error(error)
      }
    },
    async createTool(_, options) {
      try {
        await ToolApi.create(options)
      } catch (error) {
        alert.error(error)
      }
    },
    async fetchBook({ commit }, id) {
      const res = await ToolApi.fetchOne(id)
      commit('setBook', res)
      return res
    },
    resetBook({ commit }) {
      commit('resetBook')
    },
    async reportLostBook(_, { id, data }) {
      await ToolApi.reportLostBook(id, data)
    },
    async reportBook({ commit }, id) {
      const res = await ToolApi.fetchBookHistory({ book: id })
      commit('setReportBook', res)
      return res
    },
  },
  mutations: {
    setTools(state, tools) {
      state.tools = tools
    },
    setBook(state, payload) {
      state.book = payload
    },
    resetBook(state) {
      state.book = {}
    },
    setReportBook(state, payload) {
      state.reportBooks = payload
    },
  },
}
